import axios from "axios";

// Auto-detect API URL: use environment variable or current origin
const getApiUrl = () => {
  // First check environment variable
  if (process.env.REACT_APP_BACKEND_URL) {
    return process.env.REACT_APP_BACKEND_URL;
  }
  // Fallback to current origin (same domain deployment)
  return window.location.origin;
};

const API_URL = getApiUrl();

// Create axios instance with extended timeout for AI operations
const api = axios.create({
  baseURL: `${API_URL}/api`,
  withCredentials: true,
  timeout: 120000, // Extended to 2 minutes for AI operations
});

// Add token to all requests - handle both JSON and FormData
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('auth_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  
  // Don't set Content-Type for FormData - let axios handle it
  if (config.data instanceof FormData) {
    delete config.headers['Content-Type'];
  }
  
  return config;
}, (error) => {
  return Promise.reject(error);
});

// Handle response errors with better session management
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Check if token exists but is invalid
      const token = localStorage.getItem('auth_token');
      if (token) {
        // Clear invalid token
        localStorage.removeItem('auth_token');
        console.warn('Session expired or invalid token');
      }
      // Redirect to login if not already there
      if (!window.location.pathname.includes('/login') && 
          !window.location.pathname.includes('/register')) {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;
export { API_URL };
